// extracted by mini-css-extract-plugin
export default {"table":"table_table__Rmy6C","geolink":"table_geolink__qlUCc"};